<template>
  <div id="footer">
    <ul class="footer-nav">
      <router-link to="/" tag="li">{{ $t("lang.Home.name") }}</router-link>
      <router-link to="/BestMedicalCare" tag="li">{{
        $t("lang.ServiceItems.name")
      }}</router-link>
      <router-link to="/Information" tag="li">{{
        $t("lang.InformationCenter.name")
      }}</router-link>
      <router-link to="/About" tag="li">{{
        $t("lang.About.name")
      }}</router-link>
      <router-link to="/Recruit" tag="li">{{
        $t("lang.Recruit.name")
      }}</router-link>
    </ul>
    <img class="qrcode" src="../assets/images/qrcode.jpg" alt="" />
    <p class="serve-number">“春华健康科技”服务号</p>
    <p class="phone-number">热线电话：400-808-9629</p>
    <div class="keep-on-record">
      <div v-if="isShow" class="isShow">
        <img src="../assets/images/baico.png" alt="" />
        <!--<p class="gongan">皖公网安备34019202000627号</p>-->
        <div class="gongan">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34019202000627"
            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          >
            <p style="color: #464646">
              皖公网安备 34019202000627号
            </p></a
          >
        </div>
      </div>
      <a
        target="_blank"
        style="color: #464646"
        href="https://beian.miit.gov.cn/"
        >{{ recordNo }}</a
      >
      <span style="margin-left: 10px;">春华健康科技有限公司版权所有</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    handleLiClick() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push("/");
    }
  },
  computed: {
    recordNo() {
      let href = window.location.hostname;
      if ("www.chunhuahealth.com" == href) {
        return "皖ICP备19007047号-1";
      } else if ("www.chunhua-inc.com" == href) {
        return "皖ICP备19007047号-2";
      } else if ("www.chg-inc.cn" == href) {
        return "皖ICP备19007047号-3";
      } else {
        return "皖ICP备19007047号";
      }
    },
    isShow() {
      let href = window.location.hostname;
      return "www.chunhuahealth.com" == href;
    }
  }
};
</script>

<style lang="scss" scoped>
#footer {
  height: 360px;
  width: 100%;
  min-width: 1200px;
  background: #eeeeee;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  .footer-nav {
    margin-top: 50px;
    display: flex;
    li {
      margin: 0 50px;
      color: #1e1e1e;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .qrcode {
    height: 120px;
    width: 120px;
    margin-top: 65px;
  }
  .serve-number {
    margin-top: 20px;
    color: #464646;
    font-size: 12px;
  }
  .phone-number {
    margin-top: 10px;
    color: #464646;
    font-size: 12px;
  }
  .keep-on-record {
    margin-top: 10px;
    color: #464646;
    font-size: 12px;
    display: flex;
    align-items: center;
    .isShow {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 15px;
    }
  }
}
</style>
